module.exports = __webpack_public_path__ + "static/media/champignons.69d6040b.svg";